.a{display:flex;}